<script>
  import { fly } from 'svelte/transition'
  export let articles
  export let idx
</script>

<style>
  .news-card {
    display: grid;
    justify-items: center;
    text-align: center;
    background-color: rgb(255, 255, 255, 0.8);
    color: #494d4e;
    border-radius: 5px;
    box-shadow: -5px 19px 38px rgba(0, 0, 0, 0.3),
      -5px 15px 12px rgba(0, 0, 0, 0.22);
    grid-gap: 0.5em;
    overflow-y: auto;
    overflow-x: hidden;
    max-width: 30vw;
  }

  @media only screen and (max-width: 1098px) {
    .news-card {
      max-width: 50vw;
    }
  }

  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #494d4e;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: linear-gradient(
      to bottom,
      rgb(10, 199, 233) 0%,
      rgb(42, 144, 170) 75%,
      rgb(36, 83, 104) 100%
    );
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #295a81;
  }

  .news-content {
    display: grid;
    grid-gap: 0.5em;
    margin-bottom: 1em;
    justify-items: center;
    align-items: center;
  }

  a {
    background-color: #494d4e;
    color: white;
    transition: all 0.3s ease-in;
    padding: 0.5em;
    margin-bottom: 1em;
    border-radius: 5px;
    font-weight: bold;
  }

  a:hover {
    background-color: white;
    color: #494d4e;
    text-decoration: none;
  }

  h2 {
    font-size: 2vh;
  }

  h2,
  p {
    margin: 0;
    padding: 0 1em;
  }

  img {
    border-radius: 5px 5px 0 0;
  }
</style>

<div in:fly={{ y: -250, duration: 700, delay: 0 }} class="news-card">
  {#each articles as article}
    <img src={article[idx].urlToImage} alt={article[idx].title} />
    <div class="news-content">
      <h2>{article[idx].title}</h2>
      <p>{article[idx].description}</p>
      <a href={article[idx].url}>Read story</a>
    </div>
  {/each}
</div>
